export type IconsId =
  | 'zoom'
  | 'zoom-out'
  | 'zoom-in'
  | 'youtube'
  | 'wishlist'
  | 'wishlist-fill'
  | 'wings'
  | 'upload'
  | 'twitter'
  | 'tshirt'
  | 'trousers'
  | 'toys'
  | 'tick'
  | 'symbol-list'
  | 'stockist'
  | 'star'
  | 'star-pwa'
  | 'star-empty'
  | 'shop-search'
  | 'shoes'
  | 'share'
  | 'share-1'
  | 'settings'
  | 'search'
  | 'saddle'
  | 'saddle-pad'
  | 'rugs'
  | 'rosette'
  | 'rewards'
  | 'reward'
  | 'return'
  | 'rate-half'
  | 'rate-full'
  | 'rate-empty'
  | 'profile'
  | 'profile-outline'
  | 'print'
  | 'plus'
  | 'plus-2'
  | 'pinterest'
  | 'phone'
  | 'phone-inline'
  | 'outfit'
  | 'notification'
  | 'missions'
  | 'mission'
  | 'mission-outline'
  | 'minus'
  | 'menu'
  | 'martingales'
  | 'longsleeve'
  | 'logout'
  | 'lock'
  | 'location'
  | 'linkedin'
  | 'instagram'
  | 'i'
  | 'horse'
  | 'horse-head'
  | 'horse-head-outline'
  | 'hoodie'
  | 'home'
  | 'helmet'
  | 'headcollars'
  | 'grooming'
  | 'grid-4'
  | 'grid-3'
  | 'grid-2'
  | 'grid-1'
  | 'gloves'
  | 'gift'
  | 'gift-2'
  | 'full-arrow'
  | 'flyhood'
  | 'faqs'
  | 'facebook'
  | 'email'
  | 'edit'
  | 'earth'
  | 'download'
  | 'delivery'
  | 'credit-cards'
  | 'copy'
  | 'contact'
  | 'contact-us'
  | 'community'
  | 'coins'
  | 'coat'
  | 'close'
  | 'clock'
  | 'chevron2-right'
  | 'chevron2-left'
  | 'chevron'
  | 'chevron-right'
  | 'chevron-left'
  | 'chat'
  | 'card'
  | 'call'
  | 'bridle'
  | 'box'
  | 'basket'
  | 'basket-add'
  | 'arrow-up'
  | 'arrow-simple-right'
  | 'arrow-simple-left'
  | 'arrow-right'
  | 'arrow-right-bold'
  | 'arrow-left'
  | 'arrow-down'
  | 'app-search'
  | 'app-home'
  | 'app-community'
  | 'app-basket'
  | 'app-account'
  | 'address-book'
  | 'account'
  | '24-close';

export type IconsKey =
  | 'Zoom'
  | 'ZoomOut'
  | 'ZoomIn'
  | 'Youtube'
  | 'Wishlist'
  | 'WishlistFill'
  | 'Wings'
  | 'Upload'
  | 'Twitter'
  | 'Tshirt'
  | 'Trousers'
  | 'Toys'
  | 'Tick'
  | 'SymbolList'
  | 'Stockist'
  | 'Star'
  | 'StarPwa'
  | 'StarEmpty'
  | 'ShopSearch'
  | 'Shoes'
  | 'Share'
  | 'Share1'
  | 'Settings'
  | 'Search'
  | 'Saddle'
  | 'SaddlePad'
  | 'Rugs'
  | 'Rosette'
  | 'Rewards'
  | 'Reward'
  | 'Return'
  | 'RateHalf'
  | 'RateFull'
  | 'RateEmpty'
  | 'Profile'
  | 'ProfileOutline'
  | 'Print'
  | 'Plus'
  | 'Plus2'
  | 'Pinterest'
  | 'Phone'
  | 'PhoneInline'
  | 'Outfit'
  | 'Notification'
  | 'Missions'
  | 'Mission'
  | 'MissionOutline'
  | 'Minus'
  | 'Menu'
  | 'Martingales'
  | 'Longsleeve'
  | 'Logout'
  | 'Lock'
  | 'Location'
  | 'Linkedin'
  | 'Instagram'
  | 'I'
  | 'Horse'
  | 'HorseHead'
  | 'HorseHeadOutline'
  | 'Hoodie'
  | 'Home'
  | 'Helmet'
  | 'Headcollars'
  | 'Grooming'
  | 'Grid4'
  | 'Grid3'
  | 'Grid2'
  | 'Grid1'
  | 'Gloves'
  | 'Gift'
  | 'Gift2'
  | 'FullArrow'
  | 'Flyhood'
  | 'Faqs'
  | 'Facebook'
  | 'Email'
  | 'Edit'
  | 'Earth'
  | 'Download'
  | 'Delivery'
  | 'CreditCards'
  | 'Copy'
  | 'Contact'
  | 'ContactUs'
  | 'Community'
  | 'Coins'
  | 'Coat'
  | 'Close'
  | 'Clock'
  | 'Chevron2Right'
  | 'Chevron2Left'
  | 'Chevron'
  | 'ChevronRight'
  | 'ChevronLeft'
  | 'Chat'
  | 'Card'
  | 'Call'
  | 'Bridle'
  | 'Box'
  | 'Basket'
  | 'BasketAdd'
  | 'ArrowUp'
  | 'ArrowSimpleRight'
  | 'ArrowSimpleLeft'
  | 'ArrowRight'
  | 'ArrowRightBold'
  | 'ArrowLeft'
  | 'ArrowDown'
  | 'AppSearch'
  | 'AppHome'
  | 'AppCommunity'
  | 'AppBasket'
  | 'AppAccount'
  | 'AddressBook'
  | 'Account'
  | 'i24Close';

export enum Icons {
  Zoom = 'zoom',
  ZoomOut = 'zoom-out',
  ZoomIn = 'zoom-in',
  Youtube = 'youtube',
  Wishlist = 'wishlist',
  WishlistFill = 'wishlist-fill',
  Wings = 'wings',
  Upload = 'upload',
  Twitter = 'twitter',
  Tshirt = 'tshirt',
  Trousers = 'trousers',
  Toys = 'toys',
  Tick = 'tick',
  SymbolList = 'symbol-list',
  Stockist = 'stockist',
  Star = 'star',
  StarPwa = 'star-pwa',
  StarEmpty = 'star-empty',
  ShopSearch = 'shop-search',
  Shoes = 'shoes',
  Share = 'share',
  Share1 = 'share-1',
  Settings = 'settings',
  Search = 'search',
  Saddle = 'saddle',
  SaddlePad = 'saddle-pad',
  Rugs = 'rugs',
  Rosette = 'rosette',
  Rewards = 'rewards',
  Reward = 'reward',
  Return = 'return',
  RateHalf = 'rate-half',
  RateFull = 'rate-full',
  RateEmpty = 'rate-empty',
  Profile = 'profile',
  ProfileOutline = 'profile-outline',
  Print = 'print',
  Plus = 'plus',
  Plus2 = 'plus-2',
  Pinterest = 'pinterest',
  Phone = 'phone',
  PhoneInline = 'phone-inline',
  Outfit = 'outfit',
  Notification = 'notification',
  Missions = 'missions',
  Mission = 'mission',
  MissionOutline = 'mission-outline',
  Minus = 'minus',
  Menu = 'menu',
  Martingales = 'martingales',
  Longsleeve = 'longsleeve',
  Logout = 'logout',
  Lock = 'lock',
  Location = 'location',
  Linkedin = 'linkedin',
  Instagram = 'instagram',
  I = 'i',
  Horse = 'horse',
  HorseHead = 'horse-head',
  HorseHeadOutline = 'horse-head-outline',
  Hoodie = 'hoodie',
  Home = 'home',
  Helmet = 'helmet',
  Headcollars = 'headcollars',
  Grooming = 'grooming',
  Grid4 = 'grid-4',
  Grid3 = 'grid-3',
  Grid2 = 'grid-2',
  Grid1 = 'grid-1',
  Gloves = 'gloves',
  Gift = 'gift',
  Gift2 = 'gift-2',
  FullArrow = 'full-arrow',
  Flyhood = 'flyhood',
  Faqs = 'faqs',
  Facebook = 'facebook',
  Email = 'email',
  Edit = 'edit',
  Earth = 'earth',
  Download = 'download',
  Delivery = 'delivery',
  CreditCards = 'credit-cards',
  Copy = 'copy',
  Contact = 'contact',
  ContactUs = 'contact-us',
  Community = 'community',
  Coins = 'coins',
  Coat = 'coat',
  Close = 'close',
  Clock = 'clock',
  Chevron2Right = 'chevron2-right',
  Chevron2Left = 'chevron2-left',
  Chevron = 'chevron',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  Chat = 'chat',
  Card = 'card',
  Call = 'call',
  Bridle = 'bridle',
  Box = 'box',
  Basket = 'basket',
  BasketAdd = 'basket-add',
  ArrowUp = 'arrow-up',
  ArrowSimpleRight = 'arrow-simple-right',
  ArrowSimpleLeft = 'arrow-simple-left',
  ArrowRight = 'arrow-right',
  ArrowRightBold = 'arrow-right-bold',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  AppSearch = 'app-search',
  AppHome = 'app-home',
  AppCommunity = 'app-community',
  AppBasket = 'app-basket',
  AppAccount = 'app-account',
  AddressBook = 'address-book',
  Account = 'account',
  i24Close = '24-close',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Zoom]: '61697',
  [Icons.ZoomOut]: '61698',
  [Icons.ZoomIn]: '61699',
  [Icons.Youtube]: '61700',
  [Icons.Wishlist]: '61701',
  [Icons.WishlistFill]: '61702',
  [Icons.Wings]: '61703',
  [Icons.Upload]: '61704',
  [Icons.Twitter]: '61705',
  [Icons.Tshirt]: '61706',
  [Icons.Trousers]: '61707',
  [Icons.Toys]: '61708',
  [Icons.Tick]: '61709',
  [Icons.SymbolList]: '61710',
  [Icons.Stockist]: '61711',
  [Icons.Star]: '61712',
  [Icons.StarPwa]: '61713',
  [Icons.StarEmpty]: '61714',
  [Icons.ShopSearch]: '61715',
  [Icons.Shoes]: '61716',
  [Icons.Share]: '61717',
  [Icons.Share1]: '61718',
  [Icons.Settings]: '61719',
  [Icons.Search]: '61720',
  [Icons.Saddle]: '61721',
  [Icons.SaddlePad]: '61722',
  [Icons.Rugs]: '61723',
  [Icons.Rosette]: '61724',
  [Icons.Rewards]: '61725',
  [Icons.Reward]: '61726',
  [Icons.Return]: '61727',
  [Icons.RateHalf]: '61728',
  [Icons.RateFull]: '61729',
  [Icons.RateEmpty]: '61730',
  [Icons.Profile]: '61731',
  [Icons.ProfileOutline]: '61732',
  [Icons.Print]: '61733',
  [Icons.Plus]: '61734',
  [Icons.Plus2]: '61735',
  [Icons.Pinterest]: '61736',
  [Icons.Phone]: '61737',
  [Icons.PhoneInline]: '61738',
  [Icons.Outfit]: '61739',
  [Icons.Notification]: '61740',
  [Icons.Missions]: '61741',
  [Icons.Mission]: '61742',
  [Icons.MissionOutline]: '61743',
  [Icons.Minus]: '61744',
  [Icons.Menu]: '61745',
  [Icons.Martingales]: '61746',
  [Icons.Longsleeve]: '61747',
  [Icons.Logout]: '61748',
  [Icons.Lock]: '61749',
  [Icons.Location]: '61750',
  [Icons.Linkedin]: '61751',
  [Icons.Instagram]: '61752',
  [Icons.I]: '61753',
  [Icons.Horse]: '61754',
  [Icons.HorseHead]: '61755',
  [Icons.HorseHeadOutline]: '61756',
  [Icons.Hoodie]: '61757',
  [Icons.Home]: '61758',
  [Icons.Helmet]: '61759',
  [Icons.Headcollars]: '61760',
  [Icons.Grooming]: '61761',
  [Icons.Grid4]: '61762',
  [Icons.Grid3]: '61763',
  [Icons.Grid2]: '61764',
  [Icons.Grid1]: '61765',
  [Icons.Gloves]: '61766',
  [Icons.Gift]: '61767',
  [Icons.Gift2]: '61768',
  [Icons.FullArrow]: '61769',
  [Icons.Flyhood]: '61770',
  [Icons.Faqs]: '61771',
  [Icons.Facebook]: '61772',
  [Icons.Email]: '61773',
  [Icons.Edit]: '61774',
  [Icons.Earth]: '61775',
  [Icons.Download]: '61776',
  [Icons.Delivery]: '61777',
  [Icons.CreditCards]: '61778',
  [Icons.Copy]: '61779',
  [Icons.Contact]: '61780',
  [Icons.ContactUs]: '61781',
  [Icons.Community]: '61782',
  [Icons.Coins]: '61783',
  [Icons.Coat]: '61784',
  [Icons.Close]: '61785',
  [Icons.Clock]: '61786',
  [Icons.Chevron2Right]: '61787',
  [Icons.Chevron2Left]: '61788',
  [Icons.Chevron]: '61789',
  [Icons.ChevronRight]: '61790',
  [Icons.ChevronLeft]: '61791',
  [Icons.Chat]: '61792',
  [Icons.Card]: '61793',
  [Icons.Call]: '61794',
  [Icons.Bridle]: '61795',
  [Icons.Box]: '61796',
  [Icons.Basket]: '61797',
  [Icons.BasketAdd]: '61798',
  [Icons.ArrowUp]: '61799',
  [Icons.ArrowSimpleRight]: '61800',
  [Icons.ArrowSimpleLeft]: '61801',
  [Icons.ArrowRight]: '61802',
  [Icons.ArrowRightBold]: '61803',
  [Icons.ArrowLeft]: '61804',
  [Icons.ArrowDown]: '61805',
  [Icons.AppSearch]: '61806',
  [Icons.AppHome]: '61807',
  [Icons.AppCommunity]: '61808',
  [Icons.AppBasket]: '61809',
  [Icons.AppAccount]: '61810',
  [Icons.AddressBook]: '61811',
  [Icons.Account]: '61812',
  [Icons.i24Close]: '61813',
};
